<template>
  <div class="input-keyboard">
    <div class="input-c">
      <el-input
        v-model="inputValue"
        :autofocus="autofocus"
        :class="inputClass"
        :suffix-icon="suffixIcon"
        :prefix-icon="prefixIcon"
        :type="type"
        :show-password="showPassword"
        :rows="rows"
        :show-word-limit="showWordLimit"
        :disabled="disabled"
        :maxlength="maxlength"
        :clearable="clearable"
        :size="size"
        :placeholder="placeholder"
        @focus="focusInput($event)"
        @input="inputFun"
        @blur="blur"
      >
        <template v-if="appendPort" slot="append">[1-65535]</template>
      </el-input>
    </div>
    <SimpleKeyboard
      :ref="keyboardClass"
      :keyboard-class="keyboardClass"
      :input="inputValue"
      :max-length="maxlength"
      @onChange="onChange"
      @onKeyPress="onKeyPress"
    />
  </div>
</template>

<script>
import SimpleKeyboard from './SimpleKeyBoard.vue'

export default {
  name: 'KeyboardInput',
  components: {
    SimpleKeyboard
  },
  props: {
    keyboardClass: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    field: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    showPassword: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 0
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: 20
    },
    clearable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    appendPort: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: ''
    },
    suffixIcon: {
      type: String,
      default: ''
    },
    prefixIcon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      input: null,
      inputEle: null
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('inputChange', value, this.field)
      }
    }
  },
  methods: {
    inputChange() {
      this.$emit('inputChange')
    },
    inputFun() {
      this.$emit('input')
    },
    focusInput(e) {
      this.inputEle = e.srcElement
      // 关闭所有keyboard
      let arr = document.querySelectorAll('.hg-theme-default')
      arr.forEach((ele) => {
        ele.style.visibility = 'hidden'
      })

      // 打开当前输入框的keyboard
      let currentKeyborad = this.$refs[this.keyboardClass]
      currentKeyborad.$el.style.visibility = 'visible'
      this.$emit('focus')
    },
    blur() {
      this.$emit('blur')
    },
    onChange(input) {
      this.inputValue = input
      // 解决当输入框为密码输入框时，切换显示/隐藏密码，光标在开头问题，注意：element-ui版本号需为2.15.2及以上
      this.inputEle.focus()
    },
    onKeyPress(button) {
      this.$emit('onKeyPress')
      // console.log('onKeyPress', button);
    }
  }
}
</script>

<style lang="scss" scoped>
.input-keyboard {
  v-deep.hg-theme-default {
    position: fixed;
    left: 50%;
    bottom: 20px;
    transform: translate(-50%);
    visibility: hidden;
    margin-top: 20px;
    z-index: 2000;
    // 中文文字选择框
    .hg-candidate-box {
      position: static;
      transform: translateY(0);
    }
  }
  &.citc-search-input {
    .el-input {
      width: 100% !important;
    }
  }
  // 密码输入框显示密码图标效果
  v-deep.el-input__inner[type='text'] + span .el-icon-view {
    color: red;
  }
}
</style>
